// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// takes validation messages as:
// [{
//   entityId: 1,
//   header: 'Sample header',
//   messages: ['Sample Message']
// }, {
//   entityId: 2,
//   header: 'Sample header',
//   messages: ['Sample Message']
// }]

// and returns:
// {
//   '1': {
//     heading: 'Sample Header',
//     messages: ['Sample Message'],
//   },
//   '2': {
//     heading: 'Sample Header',
//     messages: ['Sample Message'],
//   },
// }

const parseValidationMessages = validationObjects => (
  validationObjects.reduce((a, d, i) => {
    if (a[d.entityId] === undefined) {
      a[d.entityId] = {
        heading: d.header,
        messages: [...d.messages],
      }
    } else {
      a[d.entityId].messages.push(...d.messages)
    }
    return a
  }, {})
)

export default parseValidationMessages
